import { Item } from './Item';

interface Modal<T extends Item = Item> {
  id: string;
  value?: T;
  children?: Modal[];
  parent?: Modal;
}

export const enrichModel = (model: Modal | undefined, parent: Modal | undefined): Modal => {
  if (model) {
    model.parent = parent;
    model.children?.forEach((c) => {
      c.parent = parent;
      if (c.children) {
        enrichModel(c, model);
      }
    });
    return model;
  } else {
    throw new Error('Model can not be undefined');
  }
};

export default Modal;
